import React, { useState, useEffect } from 'react'
// import { Button, Menu, MenuItem } from '@mui/material'
// import GTranslateOutlinedIcon from '@mui/icons-material/GTranslateOutlined';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from "react-router-dom";

import './LangModal.scss'

const LangModal = () => {
    // const [anchorEl, setAnchorEl] = useState(null)
    // const open = Boolean(anchorEl)
    // const openMenu = (e) => setAnchorEl(e.currentTarget)
    // const closeMenu = () => setAnchorEl(null)
    const { i18n, t } = useTranslation();

    const [searchParams, setSearchParams] = useSearchParams();
    const defLang = searchParams.get("current-locale")
    const lang = defLang?.slice(0, 2) || localStorage.getItem('i18nextLng')
    const [currentLang, setCurrentLang] = useState(lang)

    // const changeLanguage = (lang) => {
    //     i18n.changeLanguage(lang)
    //     setCurrentLang(lang)
    //     closeMenu()
    // };

    const onChangeLang = () => {
      if (lang === 'ru') {
        searchParams.delete('current-locale')
        setCurrentLang('en')
        i18n.changeLanguage('en')
      } else {
        searchParams.delete('current-locale')
        setCurrentLang('ru')
        i18n.changeLanguage('ru')
      }
    }

    // const langs = [
    //     { id: 1, label: `${t('lang.english')}`, code: "en" },
    //     { id: 2, label: `${t('lang.russian')}`, code: "ru" },
    //     { id: 3, label: `${t('lang.german')}`, code: "de" },
    //     { id: 4, label: `${t('lang.poland')}`, code: "pl" },
    // ]

    useEffect(()=>{
      localStorage.setItem('i18nextLng', lang)
      i18n.changeLanguage(lang)
    }, [])

    return (
        <div>
          <div className="header__rigth">
            <div className="header__lang"
                 onClick={() => onChangeLang()}>
              <div className="header__btn">
                <strong
                  className={lang === "en" ? "header__lang active" : "header__lang"}
                >EN
                </strong>
                <span> </span>
                <strong
                  className={lang === "ru" ? "header__lang active" : "header__lang"}
                >RU
                </strong>
              </div>
            </div>
            {/*<Button*/}
            {/*    aria-controls="basic-menu"*/}
            {/*    aria-haspopup="true"*/}
            {/*    aria-expanded={open ? 'true' : undefined}*/}
            {/*    onClick={openMenu}*/}
            {/*>*/}
            {/*    <GTranslateOutlinedIcon color="action" className="lang-icon" />*/}
            {/*</Button>*/}
            {/*<Menu*/}
            {/*    anchorEl={anchorEl}*/}
            {/*    open={open}*/}
            {/*    onClose={closeMenu}*/}
            {/*    MenuListProps={{ 'aria-labelledby': 'basic-button' }}*/}
            {/*>*/}
            {/*    {langs.map(lang => (*/}
            {/*        <MenuItem*/}
            {/*            key={lang.id}*/}
            {/*            onClick={() => changeLanguage(lang.code)}>*/}
            {/*            <p className={lang.code === currentLang ? "lang-item active" : "lang-item"}*/}
            {/*            >  {lang.label} </p>*/}
            {/*        </MenuItem>*/}
            {/*    ))}*/}
            {/*</Menu>*/}
          </div>
        </div>
    )
}

export default LangModal

